import { get_AppScopes4bqeg21n0qw as get_AppScope } from './AppScope.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  _ReactiveState___init__impl__fvdp9b3rxdz1mjh763m as _ReactiveState___init__impl__fvdp9b,
  Companion_getInstance3byfqsk8b0ql6 as Companion_getInstance,
} from './ReactiveState.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import {
  $3l5vvh8yg0ier as $,
  orPromise1iucc2to2udt2 as orPromise,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { BaseReactive302n39o7i5yop as BaseReactive } from './abstracts.mjs';
import { launch1c91vkjzdi9sd as launch } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function reactiveProcess(scope, emitter) {
  scope = scope === VOID ? get_AppScope() : scope;
  return reactiveProcess$1().new_com_lightningkite_reactive_core__no_name_provided__2888mk_k$(scope, emitter);
}
var reactiveProcess$1$activate$1$1Class;
function reactiveProcess$1$activate$1$1() {
  if (reactiveProcess$1$activate$1$1Class === VOID) {
    class $ {
      constructor($this_launch, this$0) {
        this.this$0__1 = this$0;
        this.$$delegate_0__1 = $this_launch;
      }
      emit_kpj8i4_k$(value) {
        this.this$0__1.set_state_wnfcx0_k$(_ReactiveState___init__impl__fvdp9b(value));
      }
      get_coroutineContext_115oqo_k$() {
        return this.$$delegate_0__1.get_coroutineContext_115oqo_k$();
      }
    }
    initMetadataForClass($);
    reactiveProcess$1$activate$1$1Class = $;
  }
  return reactiveProcess$1$activate$1$1Class;
}
function reactiveProcess$o$activate$slambda($emitter, this$0) {
  return constructCallableReference(($this$launch, $completion) => orPromise($completion, function *($completion) {
    yield* $($emitter(new (reactiveProcess$1$activate$1$1())($this$launch, this$0), $completion), $completion);
    return Unit_instance;
  }), 1);
}
var reactiveProcess$1Class;
function reactiveProcess$1() {
  if (reactiveProcess$1Class === VOID) {
    class $ extends BaseReactive() {
      constructor($scope, $emitter) {
        return new.target.new_com_lightningkite_reactive_core__no_name_provided__2888mk_k$($scope, $emitter);
      }
      static new_com_lightningkite_reactive_core__no_name_provided__2888mk_k$($scope, $emitter, $box) {
        if ($box === VOID)
          $box = {};
        $box.$scope_1 = $scope;
        $box.$emitter_1 = $emitter;
        var $this = this.new_com_lightningkite_reactive_core_BaseReactive_2kvjp3_k$(Companion_getInstance().notActive_1, $box);
        $this.job_1 = null;
        return $this;
      }
      activate_yijg9v_k$() {
        this.set_state_wnfcx0_k$(Companion_getInstance().notReady_1);
        var tmp = this;
        tmp.job_1 = launch(this.$scope_1, VOID, VOID, reactiveProcess$o$activate$slambda(this.$emitter_1, this));
      }
      deactivate_pmdz1g_k$() {
        var tmp0_safe_receiver = this.job_1;
        if (tmp0_safe_receiver == null)
          null;
        else {
          tmp0_safe_receiver.cancel$default_8haxne_k$();
        }
        this.job_1 = null;
        this.set_state_wnfcx0_k$(Companion_getInstance().notActive_1);
      }
    }
    initMetadataForClass($);
    reactiveProcess$1Class = $;
  }
  return reactiveProcess$1Class;
}
//region block: exports
export {
  reactiveProcess as reactiveProcess2z4nh4eb606pm,
};
//endregion

//# sourceMappingURL=processes.mjs.map
